import { useCustomerUpdatesConfig } from "@/hooks/shop/useCustomerUpdatesConfig";
import { useStore } from "@/stores/useStore";
import { Badge } from "@/components/Base/Badge";
import { cn } from "@/lib/utils";
import { ClassNameValue } from "tailwind-merge";

export const CustomerUpdatesBadgeCount = ({
  className,
}: {
  className?: ClassNameValue;
}) => {
  const customerUpdatesBadgeCount = useStore(
    (s) => s.customerUpdatesBadgeCount
  );

  const customerUpdateConfig = useCustomerUpdatesConfig();

  if (!customerUpdateConfig.enabled || customerUpdatesBadgeCount === 0) {
    return null;
  }

  return (
    <Badge
      type="small"
      variant="destructive"
      className={cn(
        "absolute -right-1 top-0.5 flex h-6 w-6 items-center justify-center text-base font-medium",
        className
      )}
    >
      {customerUpdatesBadgeCount > 9 ? "9+" : customerUpdatesBadgeCount}
    </Badge>
  );
};
